import { EnumBase } from 'hay-core-react';
class UsuarioTransacaoTipoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.usuariotransacao.tipo.pix',
                'main.usuariotransacao.tipo.cartaocredito',
                'main.usuariotransacao.tipo.cartaodebito',
            ],
            'main.usuariotransacao.tipo.pix'
        );
    }
}

const instance = new UsuarioTransacaoTipoEnum();
export default instance;
